/**
 * @desc 查询汇总库存信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(positionCode: string | number, options?: any) {
  return updateResponse(
    http(URL + `/stockPool/groupForPosition/${positionCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
